import { Session } from '../types';

interface WithSession {
  session?: Session;
}

interface GetPromoCodeProps<T> {
  session?: Session;
  actionData?: T;
}

export default function getPromoCode<T extends WithSession = WithSession>({
  session,
  actionData,
}: GetPromoCodeProps<T>) {
  const promoCode = actionData?.session?.cart?.promo_code ?? session?.cart?.promo_code;

  // TODO: remove fallback once we are certain that all carts with existing promo codes are updated to also have the reward data in the cart too
  const promoCodeReward = actionData?.session?.cart?.promo_code_reward ??
    session?.cart?.promo_code_reward ?? {
      type: 'mileage',
      amount: 100,
    };

  return { promoCode, promoCodeReward };
}
